module.exports = __webpack_public_path__ + "static/media/file-excel.72841c12.svg";